import {
  UPDATE,
} from '../states/select';

const reducers = (state = {}, { type, ...action }) => {
  switch (type) {
    case UPDATE:
      return action;

    default:
      return state;
  }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/data/reducers/select.js